// test1644
(1644 && 0);
